import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./modules/home/pages/homePage";
import UserManagementPage from "./modules/userManagement/pages/userManagementPage";
import CreateCampaignPage from "./modules/createCampaign/pages/createCampaignPage/createCampaignPage";
import CampaignPage from "./modules/campaign/pages/campaignPage";
import LoginPage from "./modules/login/pages/loginPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RootState, useAppSelector } from "./store";
import { UserDataModel } from "./common/models/userDataModel";
import CampaignResultPage from "./modules/campaignResult/pages/campaignResultPage";
import { useEffect } from "react";

export default function App() {
  const userData = useAppSelector((state: RootState) => state.user);
  const userDataFromStorage = JSON.parse(
    localStorage.getItem("techsauce-campaign-user-data") ?? "{}"
  ) as UserDataModel;

  useEffect(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  }, []);

  return (
    <div className="App">
      <Router>
        {userData.token || userDataFromStorage.token ? (
          <Routes>
            <Route path="/" element={<RedirectPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/admin" element={<LoginPage />} />
            <Route path="/user-management" element={<UserManagementPage />} />
            <Route path="/create-campaign" element={<CreateCampaignPage />} />
            <Route path="/edit-campaign" element={<CreateCampaignPage />} />
            <Route path="/campaign-result" element={<CampaignResultPage />} />
            <Route path="*" element={<CampaignPage />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/admin" element={<LoginPage />} />
            <Route path="*" element={<CampaignPage />} />
          </Routes>
        )}
      </Router>
      <ToastContainer position="bottom-right" />
    </div>
  );
}

const RedirectPage = () => {
  useEffect(() => {
    window.location.replace("https://techsauce.co");
  }, []);
  return null;
};
